import { Fragment } from "react"
import Navbar from "../atoms/navbar"

interface Props {
  title: string
  navNavigateUrl: string
  children: React.ReactNode
}

const TempLayout = ({ title, navNavigateUrl, children }: Props) => {
  return (
    <Fragment>
      <Navbar title={title} back navigate={navNavigateUrl} />

      <div className="w-full min-h-[500px] px-4 py-7">{children}</div>
    </Fragment>
  )
}

export default TempLayout
